<template>
  <div>

     <sms-verify v-if="!is_verify" :is_restore="false" @verified="verified"/>

     <div v-else>
           <fg-input
                type="tel"
                name="phone"
                label="Номер телефона"
                v-model="phone"
                v-mask="'+998#########'"
                placeholder="+998"
                :readonly="true"
          ></fg-input>
           <fg-input
                type="text"
                name="last_name"
                label="Ваша фамилия"
                v-model="last_name"
                placeholder=""
          ></fg-input>
           <fg-input
                  type="text"
                  label="Ваше имя"
                  v-model="first_name"
                  name="first_name"

          ></fg-input>
          <fg-input
                type="password"
                label="Пароль"
                v-model="password"
                name="password"
     
          ></fg-input>
          <fg-input
                  type="password"
                  label="Повторите пароль"
                  name="password_confirmation"
                  v-model="password_confirmation"

          ></fg-input>
          <br />
          <p-button
            class="w-100 mb-3"
            type="warning"
            round
            @click.native.prevent="submit"
            >{{'send' | setText('Отправить')}}</p-button
          >
          </div>
</div>
</template>

<script>
import { errorNotify } from "@/plugins/functions";
import SmsVerify from "@/components/Auth/SmsVerify";
export default {
  name: "login",
  components: {
      SmsVerify
  },
  mounted() {},
  data() {
    return {
      is_verify:false,
      phone: "",
      password: "",
      password_confirmation: "",
      key:"",
      last_name:"",
      first_name:"",
    };
  },
  methods: {
    submit(){
    this.$loading(true);
      this.$http
        .post("auth/register", {
          phone: this.phone,
          password: this.password,
          password_confirmation: this.password_confirmation,
          key: this.key,
          last_name: this.last_name,
          first_name: this.first_name,
        })
        .then((response) => {
              let token = response.data.data.access.accessToken;
              this.$http.defaults.headers.common["Authorization"] = `Bearer ${token}`;
              this.$http.defaults.headers.common["root"] = null;
              this.$http.defaults.headers.common["bid"] = null;

              localStorage.setItem("token", `Bearer ${token}`);
              localStorage.removeItem('root');
              localStorage.removeItem('bid');
              this.$store.dispatch("setUser", response.data.data);
              this.$store.dispatch("setRoot", false);
              this.$store.dispatch("setBusiness", null);
              this.$store.dispatch("setRoles", response.data.data.roles);
              this.$store.dispatch("setLocations", response.data.data.locations);

        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });
    },
    verified(val){
        if (val.phone && val.key){
              this.key = val.key;
              this.phone = val.phone;
              this.is_verify = true;
        }
    }
  },
};
</script>
<style>
</style>
